import { DialogController } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';

@autoinject
export class OkCancel {

    //
    private _title: string = null;
    private _message : string = null;
    private _disableCancel : boolean = false;
    private _answer: string = null;
    private _dialogController: DialogController = null;

    /**
     * Creates an instance of Prompt.
     * 
     * @param {DialogController} dialogController
     * 
     * @memberOf Prompt
     */
    constructor(dialogController: DialogController) {
        this._dialogController = dialogController;
        this._answer = null;

        this._dialogController.settings.centerHorizontalOnly = true;
    }

    /**
     * 
     * 
     * @param {any} message
     * 
     * @memberOf Prompt
     */
    activate(model: any) {
        this._title = model.title;
        this._message = model.message;
        this._disableCancel = model.disableCancel;
    }
}